import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'pdf-viewer-page',
  templateUrl: './pdf-viewer-page.component.html',
  styleUrls: ['./pdf-viewer-page.component.scss']
})
export class PdfViewerPageComponent implements OnInit, OnDestroy {
  pdfUrl: string = '';
  loading: boolean = false;

  private viewerUrl: string = '';
  private retryTimer: any;
  private retryCount: number = 0;
  private readonly maxRetries = 10;
  private readonly retryDelay = 3000;

  constructor(
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    const url = decodeURIComponent(this.route.snapshot.queryParams['url'] || '');
    if (!url) return;

    const absolute = url.startsWith('http') ? url : `${window.location.origin}${url}`;
    this.viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(absolute)}&embedded=true`;
    this.pdfUrl = this.viewerUrl;
    this.loading = true;

    // Google Docs viewer sometimes returns 204 on first load — schedule retries
    this.scheduleRetry();
  }

  onFrameLoad() {
    // Each successful load event cancels the pending retry and hides the loader
    clearTimeout(this.retryTimer);
    this.loading = false;
  }

  private scheduleRetry() {
    if (this.retryCount >= this.maxRetries) {
      this.loading = false;
      return;
    }
    this.retryTimer = setTimeout(() => {
      this.retryCount++;
      this.pdfUrl = `${this.viewerUrl}&t=${Date.now()}`;
      this.scheduleRetry();
    }, this.retryDelay);
  }

  ngOnDestroy() {
    clearTimeout(this.retryTimer);
  }

  goBack() {
    this.location.back();
  }
}
